import React from 'react';
import './WorkUtilization.css';
import { getPercent } from '../../../../../utils/getPercent';

const WorkUtilization = ({ data }) => {
    const colorPalette = ['#e53935', '#fbc02d', '#43a047', '#1e88e5', '#8e24aa'];

    // Add color to each item in the `data` array
    const projects = data?.projectUtilization?.map((item, index) => ({
        ...item,
        color: colorPalette[index % colorPalette.length],
        max: data?.availableEngineersCount,
    }));

    return (
        <div className="work-utilization-container">
            <span className="work-utilization-title">Work Utilization</span>

            {projects?.length > 0 ? (
                projects?.map((project, index) => {
                    const percentage = (project?.engineer_count / project?.max) * 100;
                    // const percentage = getPercent(project?.engineer_count / project?.max);
                    return (
                        <div key={index} className="project-wrapper">
                            <div className="work-utilization-section">
                                <span className="project-name">{project?.PD_ProjectName}</span>
                                <span className="project-engineers">{project?.engineer_count} Engineers</span>
                            </div>
                            <div className="progress-bar-container">
                                <div
                                    className="progress-bar-fill"
                                    style={{
                                        width: `${percentage}%`,
                                        backgroundColor: project?.color,
                                    }}
                                />
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="project-wrapper">
                    <p className="no-data-message">No records found</p>
                </div>
            )}
        </div>
    );
};

export default WorkUtilization;
